'use client'
import {
  ORGANIZER_QUERY
} from "./chunk-AWPL6XVN.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  minifyGqlQuery
} from "./chunk-UBYW5IHO.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/organizer/listing.ts
import { gql } from "graphql-request";
import { useQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var QUERY = gql`
query getOrganizerListing($lang: String, $limit: Int, $skip: Int, $where: OrganizerFilter, $order: [OrganizerOrder]) {
  organizerCollection(locale: $lang, limit: $limit, skip: $skip, where: $where, order: $order) {
    total
    items {
      ${ORGANIZER_QUERY}
    }
  }
}
`;
var getOrganizerListing = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(minifyGqlQuery(QUERY), __spreadValues({}, props));
    return res.organizerCollection;
  } catch (error) {
    throw new Exception({ error, name: "getOrganizerListingException" });
  }
});
var useGetOrganizerList = (props, options) => {
  return useQuery(__spreadProps(__spreadValues({}, options), {
    queryKey: ["getOrganizerList", props],
    queryFn: () => getOrganizerListing(props)
  }));
};

export {
  getOrganizerListing,
  useGetOrganizerList
};
//# sourceMappingURL=chunk-AI3DVZJL.mjs.map